import Layout from "@/shared/layouts/layout";
import ProtectedRoute from "./protected-route";
import SubscriptionProtectedRoute from "./subscription-protected-route";

const ProtectedLayout = () => (
  <ProtectedRoute redirectTo="/login">
    <SubscriptionProtectedRoute>
      <Layout />
    </SubscriptionProtectedRoute>
  </ProtectedRoute>
);

export default ProtectedLayout;
